import type { ClaimCandidateStatus } from "@hp/types";
import type { PillTone } from "@hp/ui";

const IN_PROGRESS_STATUSES: ClaimCandidateStatus[] = ["validated", "filed", "allowed", "deferred"];

export function isInProgressClaimStatus(status: ClaimCandidateStatus): boolean {
  return IN_PROGRESS_STATUSES.includes(status);
}

export function needsCounselValidation(
  status: ClaimCandidateStatus,
  counselValidatedAt: string | null | undefined,
): boolean {
  return isInProgressClaimStatus(status) && !counselValidatedAt;
}

export interface ClaimStatusDisplay {
  label: string;
  tone: PillTone;
  useStandardPill: boolean;
}

export function claimStatusDisplay(
  status: ClaimCandidateStatus,
  counselValidatedAt?: string | null,
): ClaimStatusDisplay {
  if (status === "validated" && counselValidatedAt) {
    return { label: "Validated", tone: "brand", useStandardPill: false };
  }
  if (needsCounselValidation(status, counselValidatedAt)) {
    return { label: "In progress", tone: "warning", useStandardPill: false };
  }
  return { label: status, tone: "neutral", useStandardPill: true };
}
